/**
 * Neue App-Version erkennen (F-47) - rein und getestet. Ohne DOM und ohne
 * Netz; die Anbindung steht in `app/neueVersion.ts`.
 */

const MUSTER = /^[0-9a-f]{6,64}$/;

/** Inhalt von version.json -> Kennung; alles Unerwartete -> `null`. */
export function kennungAusDatei(daten: unknown): string | null {
  if (typeof daten !== 'object' || daten === null) return null;
  const k = (daten as { kennung?: unknown }).kennung;
  return typeof k === 'string' && MUSTER.test(k) ? k : null;
}

/** Ungleich, nicht "neuer": auch ein Zurueckrollen bei Cloudflare ist ein Wechsel. */
export function istNeueVersion(eigene: string | null, server: string | null): boolean {
  return eigene !== null && server !== null && eigene !== server;
}

/** Schnelles Hin- und Herwechseln soll nicht jedes Mal nachfragen. */
export function pruefungFaellig(jetzt: number, zuletzt: number | null, abstandMs: number): boolean {
  return zuletzt === null || jetzt - zuletzt >= abstandMs;
}
